// ToyCommandAnimationItem.js
'use strict';
import { connect } from 'react-redux';

import ToyCommandAnimationItem from '../component/ToyCommandAnimationItem.jsx';
import getGoalData from '../selector/getGoalData.js';
import getUserData from '../selector/getUserData.js';
import fetchUser from '../action/fetchUser.js';
import getToyCommandData from '../selector/getToyCommandData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

const mapStateToProps = (state, { goalId, nextGoalId }) => {
  const isToyCommandAnimationStarted = getGoalData(state, [goalId], 'started');
  const startUnixTimestamp = getGoalData(state, [goalId, 'context'], 'started');
  const levels = getGoalData(state, [goalId], 'levels')?.[0] || {};
  const senderId = getGoalData(state, [goalId, 'context'], 'sender_id');
  const productId = getGoalData(state, [goalId, 'context'], 'product_id');
  const preset = getGoalData(state, [goalId, 'context', 'device'], 'preset');
  const senderUsername = getUserData(state, senderId, 'username');
  const largeImage = getToyCommandData(state, preset, 'largeImage');
  const thumbnail = getToyCommandData(state, preset, 'image');

  const isFetchedLargeImage = !!getNetworkingData(
    state,
    ['resource', largeImage],
    'isFetched'
  );

  // fallback to thumbnail if large image is not fetched
  const toyCommandImage = isFetchedLargeImage ? largeImage : thumbnail;

  // Get next goal data if nextGoalId exists
  let nextProps = {};
  if (nextGoalId) {
    const nextLevels = getGoalData(state, [nextGoalId], 'levels')?.[0] || {};
    const nextProductId = getGoalData(
      state,
      [nextGoalId, 'context'],
      'product_id'
    );
    const nextPreset = getGoalData(
      state,
      [nextGoalId, 'context', 'device'],
      'preset'
    );

    nextProps = {
      nextProductId,
      nextGoalTitle: nextLevels?.title,
      nextTarget: nextLevels?.target,
      nextIsToy: !!nextPreset,
    };
  }

  return {
    isToyCommandAnimationStarted,
    startUnixTimestamp,
    senderId,
    senderUsername,
    productId,
    goalTitle: levels?.title,
    target: levels?.target,
    preset,
    toyCommandImage,
    isFetchedLargeImage,
    ...nextProps,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToyCommandAnimationItem);
